import chroma from "chroma-js";
import { COLOR_SCHEME_LIGHT } from "../../THEME_BASE";
const globalColors = (colorScheme, baseBrandColors, baseGlobalColors) => ({
  ...baseGlobalColors,
  linkHover: chroma(baseGlobalColors.link)[colorScheme === COLOR_SCHEME_LIGHT ? "darken" : "brighten"](1).hex(),
  navigationBackground: baseGlobalColors.contentBackground,
  textAlt: baseBrandColors.secondary
});
export default globalColors;
